export const Image = ({ image, alt, loading, ...rest }) => {
  return <img src={image} alt={alt} loading={loading} {...rest} />;
};
